import $ from 'jquery';

class Preloader{

    constructor(container){
		this.container = container;
		this.preloader;
    }

    show(){
		let rotator = document.createElement('div');
		rotator.className = "rotator";

		this.preloader = document.createElement('div');
		this.preloader.className = "preloader";

		$(this.preloader).append(rotator);
		$(this.container).append(this.preloader);
        
    }
    hide(){

		$(this.preloader).fadeOut("fast", function(){
			$(this).remove();
		});
        	
    }


}

export default Preloader;